import { render, staticRenderFns } from "./FooterSailCroatia.vue?vue&type=template&id=79d185d4&scoped=true&"
import script from "./FooterSailCroatia.vue?vue&type=script&lang=ts&"
export * from "./FooterSailCroatia.vue?vue&type=script&lang=ts&"
import style0 from "./FooterSailCroatia.vue?vue&type=style&index=0&id=79d185d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d185d4",
  null
  
)

export default component.exports